import { VIP_SETTING, VIP_SYSTEM } from '~/utils/api-response/vip'

// State
export const state = () => ({
  vipTiers: {},
  vipSystem: {},
  vipSystemLoading: false,
  vipTiersLoading: false,
  isVipTierStatusActive: false
})

// Actions
export const actions = {
  getVipTiers({ commit }, params) {
    const data = VIP_SYSTEM
    if (!this.$cookie.get('token') && data?.data) {
      // Set default player info for non-logged-in users
      const tiers = data?.data?.tiers.filter(el => el.tier_type === 1)
      data.data.player = {
        condition_type: data?.data?.player?.condition_type,
        total_amount: 0,
        current_tier: {
          name: {
            ...tiers[0]?.name
          },
          id: tiers[0]?.id,
          file: tiers[0]?.file
        }
      }
    }
    commit('setVipTiers', JSON.parse(JSON.stringify(data.data)))
  },
  getVipSettings({ commit }, params) {
    const data = VIP_SETTING
    commit('setVipSystem', data?.data)
    commit('setIsVipTierStatusActive', data?.data?.status === 1)
  },
  async claimLevelUpReward({ dispatch }, tierId) {},
  async claimBirthdayReward({ dispatch }, tierId) {}
}

// Mutations
export const mutations = {
  setVipTiers: (state, data) => {
    state.vipTiers = data
  },
  setVipSystem: (state, data) => {
    state.vipSystem = data
  },
  setVipTiersLoading: (state, data) => {
    state.vipTiersLoading = data
  },
  setVipSystemLoading: (state, data) => {
    state.vipSystemLoading = data
  },
  setIsVipTierStatusActive: (state, data) => {
    state.isVipTierStatusActive = data
  }
}
